import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-page-title',
  templateUrl: './page-title.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './page-title.component.scss'
})
export class PageTitleComponent {
  @Input() title: string = "";
  @Input() subTitle: string = "";
  @Input() src: string = "";
  @Input() src2: string = "";
  @Input() hideButton: boolean = false;
  @Input() buttonText: string = "Ücretsiz deneyin";
  @Input() buttonLink: string = "https://panel.entegi.com/account/register?ref=798BI";
}
